import type {ReactElement} from 'react';
import {useContext} from 'react';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {NavDropdownMenu} from '../nav-dropdown-menu/nav-dropdown-menu';
import {HELP_MENU_HELP_CENTER_URL, HelpMenuOption} from './help-menu.types';
import styles from './help-menu.module.scss';

export function HelpMenu(): ReactElement {
  const {actions} = useContext(emailMakerContext);

  const onClick = (id?: string): void => {
    if (id === HelpMenuOption.HELP_CENTER) {
      window.open(HELP_MENU_HELP_CENTER_URL, '_blank', 'noopener');
      return;
    }
    if (id === HelpMenuOption.KEYBOARD_SHORTCUTS) {
      actions.openRightPanelKeyboardShortcuts();
    }
  };

  return <NavDropdownMenu selector={renderSelector()} items={getMenuItems()} onItemClick={onClick} popupClassName={styles.popup} />;
}

function renderSelector(): ReactElement {
  return (
    <Icon
      icon="icon-help"
      isUsedAsButton
      ariaLabel={window.i18next.t('pmwjs_help_center')}
      type={IconType.DARK_GHOST}
      shape={IconShape.SQUARE}
      size={IconSize.SIZE_ICON_20}
      className={styles.trigger}
    />
  );
}

function getMenuItems(): ControlledListItemType[] {
  return [
    {
      id: HelpMenuOption.HELP_CENTER,
      icon: 'icon-help',
      text: window.i18next.t('pmwjs_help_center'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
    },
    {
      id: HelpMenuOption.KEYBOARD_SHORTCUTS,
      icon: 'icon-keyboard',
      text: window.i18next.t('pmwjs_keyboard_shortcuts'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
    },
  ];
}
